import { render, staticRenderFns } from "./ModalAddNewGroup.vue?vue&type=template&id=e5809242&scoped=true"
import script from "./ModalAddNewGroup.vue?vue&type=script&lang=js"
export * from "./ModalAddNewGroup.vue?vue&type=script&lang=js"
import style0 from "./ModalAddNewGroup.vue?vue&type=style&index=0&id=e5809242&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5809242",
  null
  
)

export default component.exports